import React, { useEffect } from "react";
import { StyledEditField } from "./StyledEditField";
import { IField } from "../../../types/filterFields";
import { COUNTRIES } from "../../../constants/countries/countriesNationalities";

interface IEditField {
  onChange: (e: string | string[]) => void;
  className?: string;
  value: string | string[];
  objKey: string;
  placeholder?: string;
  obj?: IField;
  multiple?: boolean;
}

const EditField = ({
  obj,
  onChange,
  className,
  value,
  objKey,
  placeholder = "",
  multiple = false,
}: IEditField) => {
  const [curValue, setCurValue] = React.useState<string | string[]>(
    multiple ? (value ? value : []) : value ? value : ""
  );

  useEffect(() => {
    if (multiple) {
      setCurValue(Array.isArray(value) ? value : value ? [String(value)] : []);
    } else {
      setCurValue(Array.isArray(value) ? value[0] ?? "" : value ?? "");
    }
  }, [multiple, value]);

  const inputProps = Object.assign(
    {},
    placeholder && { placeholder },
    value && { value: curValue },
    className && { className }
  );

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCurValue(e.target.value);
    onChange(e.target.value);
  };

  return (
    <StyledEditField>
      {(obj && obj.choices) || obj?.type === "choice" ? (
        <>
          {" "}
          <label>{placeholder}</label>
          <select
            multiple={multiple}
            value={curValue}
            onChange={(e) => {
              const nextValue = multiple
                ? Array.from(e.target.selectedOptions ?? []).map(
                    (option) => option.value
                  )
                : e.target.value;
              setCurValue(nextValue);
              onChange(nextValue);
            }}
            className={className}
            // {...inputProps}
          >
            <option value="">Seleziona</option>
            {(() => {
              if (obj.key === "nazionalita" || obj.key === "cittadinanza") {
                return COUNTRIES.map((choice) => (
                  <option key={choice} value={choice}>
                    {choice}
                  </option>
                ));
              }
              if (obj?.choices) {
                return obj.choices?.map((choice) => (
                  <option key={choice} value={choice}>
                    {choice}
                  </option>
                ));
              }
            })()}
          </select>
        </>
      ) : (
        <>
          <label>{placeholder}</label>
          <input
            type={obj?.type === "date" ? "month" : "text"}
            onChange={handleChange}
            className={className}
            {...inputProps}
            value={
              obj?.type === "date" && typeof curValue === "string"
                ? curValue.substring(0, 7)
                : curValue
            }
          />
        </>
      )}
    </StyledEditField>
  );
};

export default EditField;
